import React from 'react';
import { StyledLoader } from './SkeletonLoader.styles';
import { SkeletonLoaderVariants } from './types';

export type Props = {
  /**
   *  Height in px, default is 20px
   */
  height?: number;
  /**
   * Width in px, default is 100% of the parent
   */
  width?: number;
  /**
   * Loader variant
   */
  variant?: SkeletonLoaderVariants;
};

const getBackgroundColor = (variant: SkeletonLoaderVariants) => {
  switch (variant) {
    case 'primary':
      return 'gray.extraLight';
    case 'secondary':
      return 'gray.main';
  }
};

const SkeletonLoader = ({ height, width, variant = 'primary' }: Props) => (
  <StyledLoader
    borderRadius={2}
    height={height}
    width={width}
    backgroundColor={getBackgroundColor(variant)}
  />
);

export default SkeletonLoader;
